export const en = {
    'predictor-error': 'The forecast is temporarily unavailable',
    'reach-title': 'Coverage forecast for 7 days'
};
